import { Component, Input } from '@angular/core';

@Component({
  selector: 'epicrisis-input',
  templateUrl: './epicrisis-input.component.html',
  styleUrl: './epicrisis-input.component.scss'
})
export class EpicrisisInputComponent {
  @Input() readonly: boolean = false;
  @Input() label: string = '';
  @Input() value: string = '';

  @Input() bigInput: boolean = false;

  isActive: boolean = true;

  reportSelf() {
    return {
      label: this.label,
      isActive: this.isActive,
      value: this.value
    }
  }
}
